import { Grid } from '@mantine/core';
import HeaderStatistic from '../../HeaderStatistic';
import LazyLoadSpinner from '../../LazyLoaderSpinner';

const FacebookAdStats = ({ stats, facebookAd, currency, adAccountCurrency }) => {
  let statsElement;
  if (!stats) {
    statsElement = (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    statsElement = (
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Impressions"
              stats={stats}
              stat="sent"
              id={facebookAd.id}
              statKey="count"
              costStat="spend"
              costPer={1000}
              costCurrency={adAccountCurrency}
            />
          </Grid.Col>

          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Clicks"
              stats={stats}
              stat="clicks"
              percentageOfStat="sent"
              id={facebookAd.id}
              statKey="count"
              costStat="spend"
              costCurrency={adAccountCurrency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Conversions"
              stats={stats}
              stat="conversions"
              percentageOfStat="clicks"
              id={facebookAd.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Purchases"
              stats={stats}
              stat="purchases"
              percentageOfStat="conversions"
              id={facebookAd.id}
              statKey="count"
              costStat="spend"
              costCurrency={adAccountCurrency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Revenue"
              stats={stats}
              stat="purchases"
              id={facebookAd.id}
              statKey="value"
              currency={adAccountCurrency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic
              title="Page engagements"
              stats={stats}
              stat="pageEngagements"
              id={facebookAd.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Post engagements"
              stats={stats}
              stat="postEngagements"
              id={facebookAd.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Post reactions"
              stats={stats}
              stat="postReactions"
              id={facebookAd.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic
              title="Spend"
              stats={stats}
              stat="spend"
              id={facebookAd.id}
              statKey="value"
              currency={adAccountCurrency}
            />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    );
  }
  return statsElement;
};

export default FacebookAdStats;
